<template>
  <div ref="mainDiv" class="main-div tableSelect-main" id="mainDiv">
    <div class="main-table tableSelect-left">
      <el-table
        v-loading="loading"
        @sort-change="changeSort"
        ref="normalTable"
        :data="tableData"
        border
        :row-key="(row) => {return row.id}"
        :row-class-name="tableRowClassName"
        @row-click="handleClickTableRow"
        @row-dblclick="handleDBClickLeftTableRow"
        :height="tableHeight">
        <el-table-column v-for="(item,index) in configure.columns"  v-if="item.isShow != '0'" :sortable="!!item.sortable?'custom':false"  :key="item.field" :prop="item.field" :width="item.width" :show-overflow-tooltip='true'>
          <template slot="header" slot-scope="scope">
            <div v-if="item.cellType == 'edit'" class="editor-flag"></div>
            <!-- checkbox列 -->
            <div class="header-div" v-if="item.field == 'ck'">
              <div class="header-title">
                <a class="corner-marker" v-show="multipleSelection.length > 1">{{multipleSelection.length}}</a>
                <el-checkbox v-model="allCheck" @click.native.stop="handleAllSelection($event)" />
              </div>
              <div class="header-condition" v-show="configure.isShowSearch">
                <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
              </div>
            </div>
            <!-- radio 单选列 -->
            <div class="header-div" v-else-if="item.field == 'radio'">
              <div class="header-title"></div>
              <div class="header-condition" style="text-align: center;" v-show="configure.isShowSearch">
                <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
              </div>
            </div>
            <!-- 序号 -->
            <div class="header-div" v-else-if="item.field == 'sn'">
              <div class="header-title">序号</div>
            </div>
            <!-- 正常列 -->
            <div class="header-div" :class="{'sortableColumn': !!item.sortable}" v-else>
              <div class="header-title">{{item.title}}</div>
              <div class="header-condition" v-show="configure.isShowSearch">
                <el-input v-if="item.condition&&item.condition.searchType == 'input'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submit()" v-model="item.condition.value"/>
                <el-input-number v-else-if="item.condition&&item.condition.searchType == 'number'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submit()" v-model="item.condition.value"/>
                <el-select v-else-if="item.condition&&item.condition.searchType == 'select'" filterable placeholder="" v-model="item.condition.value" @change="submit()" v-on:click.native="handleNoClick($event)">
                  <el-option  v-for="sItem in item.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>
                </el-select>
                <span v-else>&nbsp;</span>
              </div>
            </div>
          </template>
          <template #default="scope">
            <div class="table-checkbox" v-if="item.field == 'ck'" style="text-align: center;">
              <el-checkbox v-model="scope.row.checked" @click.native.stop="handleSelection($event,scope.row)"></el-checkbox>
            </div>
            <div v-else-if="item.field == 'radio'" style="text-align: center;">
              <el-radio class="radio" v-model="radio_value" :label="scope.row[configure.idField]">&nbsp;</el-radio>
            </div>
            <div v-else-if="item.field == 'sn'" style="text-align: center;">{{scope.row.index}}</div>
            <div v-else-if="item.cellType == 'edit'" :style="{textAlign: item.align?item.align:'left'}">
              <XrEditCell :editCofigure="item" :rowData="rowData(scope.row)" :editUrl="configure.editUrl" :idField="configure.idField" :refreshRowData="refreshRowData" @editDataCallback="editDataCallback"></XrEditCell>
            </div>
            <div v-else-if="item.cellType == 'click'" class="click-cell" v-html="cellView(item,scope.row)" @click="cellClick(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
            <div v-else-if="item.cellType == 'operate'" class="operate-div" :style="{textAlign: item.align?item.align:'left'}">
              <a v-for="operate in item.operateList" v-if="!operate.display||operate.display(scope.row)" @click="operate.handler(scope.row)">{{ operate.formatter?operate.formatter(scope.row):operate.text}}</a>
            </div>
            <div class="cell-normal-div" v-else v-html="cellView(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="configure.pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          :total="totalPage"
          layout="prev, pager, next,sizes,total"
        ></el-pagination>
      </div>
    </div>

    <div class="center-btn tableSelect-center" :style="{height: (tableHeight + 20) + 'px'}">
      <div class="icon" :class="{'back-gray':multipleSelection.length == 0,'back-blue': multipleSelection.length > 0}" @click="leftTransfer">
        <i class="el-icon-d-arrow-right"></i>
      </div>
      <div class="icon" :class="{'back-gray':rightMultipleSelection.length == 0,'back-blue': rightMultipleSelection.length > 0}" @click="rightTransfer">
        <i class="el-icon-d-arrow-left"></i>
      </div>
    </div>

    <div class="main-table tableSelect-right">
      <el-table
        ref="rightTable"
        :data="rightData"
        border
        :row-key="(row) => {return row.id}"
        :height="tableHeight"
      >
        <el-table-column v-for="(item,index) in configure.columns"  v-if="item.isShow != '0'" :sortable="!!item.sortable?'custom':false"  :key="item.field" :prop="item.field" :width="item.width" :show-overflow-tooltip='true'>
          <template slot="header" slot-scope="scope">
            <div v-if="item.cellType == 'edit'" class="editor-flag"></div>
            <!-- checkbox列 -->
            <div class="header-div" v-if="item.field == 'ck'">
              <div class="header-title">
                <a class="corner-marker" v-show="rightMultipleSelection.length > 1">{{rightMultipleSelection.length}}</a>
                <el-checkbox v-model="rightAllCheck" @click.native.stop="handleRightAllSelection($event)" />
              </div>
            </div>
            <!-- 序号 -->
            <div class="header-div" v-else-if="item.field == 'sn'">
              <div class="header-title">序号</div>
            </div>
            <!-- 正常列 -->
            <div class="header-div" :class="{'sortableColumn': !!item.sortable}" v-else>
              <div class="header-title">{{item.title}}</div>
              <div class="header-condition" v-show="configure.isShowSearch">
                <el-input v-if="item.condition&&item.condition.searchType == 'input'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submitRight()" v-model="item.condition.rightValue"/>
                <el-input-number v-else-if="item.condition&&item.condition.searchType == 'number'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submitRight()" v-model="item.condition.rightValue"/>
                <el-select v-else-if="item.condition&&item.condition.searchType == 'select'" filterable placeholder="" v-model="item.condition.rightValue" @change="submitRight()" v-on:click.native="handleNoClick($event)">
                  <el-option  v-for="sItem in item.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>
                </el-select>
                <span v-else>&nbsp;</span>
              </div>
            </div>
          </template>
          <template #default="scope">
            <div class="table-checkbox" v-if="item.field == 'ck'" style="text-align: center;">
              <el-checkbox v-model="scope.row.checked" @click.native.stop="handleRightSelection($event,scope.row)"></el-checkbox>
            </div>
            <div v-else-if="item.field == 'radio'" style="text-align: center;">
              <el-radio class="radio" v-model="radio_value" :label="scope.row[configure.idField]">&nbsp;</el-radio>
            </div>
            <div v-else-if="item.field == 'sn'" style="text-align: center;">{{scope.row.index}}</div>
            <div v-else-if="item.cellType == 'edit'" :style="{textAlign: item.align?item.align:'left'}">
              <XrEditCell :editCofigure="item" :rowData="rowData(scope.row)" :editUrl="configure.editUrl" :idField="configure.idField" :refreshRowData="refreshRowData" @editDataCallback="editDataCallback"></XrEditCell>
            </div>
            <div v-else-if="item.cellType == 'click'" class="click-cell" v-html="cellView(item,scope.row)" @click="cellClick(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
            <div v-else-if="item.cellType == 'operate'" class="operate-div" :style="{textAlign: item.align?item.align:'left'}">
              <a v-for="operate in item.operateList" v-if="!operate.display||operate.display(scope.row)" @click="operate.handler(scope.row)">{{ operate.formatter?operate.formatter(scope.row):operate.text}}</a>
            </div>
            <div class="cell-normal-div" v-else v-html="cellView(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import XrHeaderSearch from '../XrHeaderSearch/index'
  import XrEditCell from './editCell'

  export default {
    // table 表格
    name: 'XrTable',
    props: {
      configure: {
        type: Object,
        default: {
          url: '',
          isShowSearch: false,
          pagination: true,
          isTreeTable: false,  //是否是树状table
          isShowToolbar: {
            type: Boolean,
            default:() => true
          },
          columns: []
        }
      },
      rightData: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },
    inject: {
      clickTableRow: {
        default: 'clickTableRow'
      },
      viewRowInfo: {
        default: 'viewRowInfo'
      }
    },
    provide(){
      return{
        refreshRowData:this.refreshRowData,
        handleClickTableRow:this.handleClickTableRow
      }
    },
    data() {
      return {
        loading: false,
        isTableColumnSettingShow: false,      //是否显示表格配置页面
        editable: {},                         //可编辑的map
        allCheck: false,
        inputValue: '',
        tableHeight: 260,
        query: {},
        multipleSelection: [],                //批量选中的值
        multipleSelectionItem:[],             //批量选中的对像
        pageIndex: 1,                         //当前页码数
        pageSize: 50,                         //每页显示数
        totalPage: 0,                         //总页数
        leftSelectList: [],                   //左侧选中列表
        rightSelectList: [],                  //右侧选择列表
        rightMultipleSelection: [],           //批量选中的值
        rightMultipleSelectionItem: [],       //批量选中的对像
        rightAllCheck: false,                 //批量选中的对像
        tableDivHeight: '400px',
        tableData: [],
        radio_value: '',
        radio_row: {},
        pageSizes: [5,10,20,50,100,200,500,2000]
      }
    },
    components: {
      XrHeaderSearch,
      XrEditCell
    },
    mounted() {

    },
    created() {
      this.init();
    },
    watch: {
      rightData(val){
          this.$emit("rightDataChange",val)
      }
    },
    methods: {
      //初始化
      init: function () {
        //如果没有传入，给一个默认值
        if (this.configure.pagination == undefined) {
          this.configure.pagination = true;
        }

        if (!this.configure.pagination) {
          this.pageSize = 10000;
        }

        if (this.configure.pageSize) {
          this.pageSize = this.configure.pageSize
        }

        if (this.configure.tableHeight) {
          this.tableHeight = this.configure.tableHeight
        }

        //如果 listInfoUrl 不为空，根据接口获取信息
        if (!!this.configure.listInfoUrl) {
          this.getListInfo(this.configure.listInfoUrl);
        }else{
          if(!this.configure.defaultNoLoadData){  //默认不加载数据为false或空的时候，加载数据
            this.getData();     //获取列表数据
          }
          this.initTableColumn();   //初始化配置的列
        }
      },
      //获取 listInfo 信息
      getListInfo(listInfoUrl){
        return this.request({
          method:'post',
          url: listInfoUrl,
          params: {}
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code !== 0){
            console.log('报错了：' + response.msg);
          }

          for(let i = 0; i < this.configure.columns.length; i ++){
            let temp = this.configure.columns[i];
            if(!!temp.condition && temp.condition.searchType === 'select' && !!response.data[temp.field + '_list']){
              let list = response.data[temp.field + '_list'];
              temp.condition.selectList = list;
            }
          }

          if(!this.configure.defaultNoLoadData){  //默认不加载数据为false或空的时候，加载数据
            this.getData();     //获取列表数据
          }
          this.initTableColumn();   //初始化配置的列
        })
      },
      //获取数据
      getData() {
        //去掉全选复选框的显示
        this.cleanSelectList();   //情况选择列表
        this.loading = true;
        this.query.showCount = this.pageSize;
        this.query.page = this.pageIndex;
        if(!!this.configure.listParam){
          for (let obj in this.configure.listParam) {
            this.query[obj] = this.configure.listParam[obj]
          }
        }

        return this.request({
          method:'post',
          url: this.configure.url,
          params: this.query
        }).then((response) =>{          //这里使用了ES6的语法
          this.loading = false;
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code !== 0){
            this.$message.error(response.msg);
            return false;
          }

          if(response.data.length > 0){
            this.tableData = response.data;
            this.totalPage = response.count;
          }else if(response.rows && response.rows.length>0){
            this.tableData = response.rows;
            this.totalPage = response.rows.length;
          }else{
            this.tableData = []
          }

          this.tableData.forEach(element => {
            element['checked'] = false
            if(element.children){
              this.setChildToBeSelect(element.children,false);
            }
          });

          //选中第一行
          if(this.configure.isSelectFirst && this.tableData  != null){
            this.handleClickTableRow(this.tableData[0],'first');
          }

          this.$nextTick(()=>{ // 页面渲染完成后的回调
            if(!!this.configure.isTreeTable){
              if(!!this.configure.defaultExpandAll){  //是否默认展开
                this.toggleRowExpansionAll(this.$refs.multipleTable.data, true);
              }else{
                this.toggleRowExpansionAll(this.$refs.multipleTable.data, false);
              }
            }
          })


        })


      },
      cellView(item,row){  //单元格显示
        if(item.formatter){
          return item.formatter(row[item.field])
        }else if(item.condition&&item.condition.searchType == 'select'){
          let viewValue = '';
          for(let i = 0 ; i < item.condition.selectList.length ; i ++){
            if(item.condition.selectList[i].value == row[item.field]){
              viewValue = item.condition.selectList[i].label;
            }
          }
          return viewValue;
        }else{
          return row[item.field]
        }
      },
      //刷新选择框
      refreshSelectList(){
        let multipleSelection = [];
        let multipleSelectionItem = []
        this.tableData.forEach(item => {
          if(item.children){
            item.children.forEach(child => {
              if(child.checked){
                multipleSelection.push(child.id);
                multipleSelectionItem.push(child);
              }
            })
          }else {
            if(item.checked){
              multipleSelection.push(item.id);
              multipleSelectionItem.push(item);
            }
          }
        });
        this.multipleSelection = multipleSelection;
        this.multipleSelectionItem = multipleSelectionItem;
        //如果全选了，设置全选
        if(this.multipleSelection.length > 0 && this.multipleSelection.length == this.tableData.length){
          this.allCheck = true;
        }else {
          this.allCheck = false;
        }

        //单行事件【选择后的回到事件】
        if(this.configure.onCheckChange){
          this.configure.onCheckChange(multipleSelectionItem);
        }
      },
      //清空选择框
      cleanSelectList(){
        this.multipleSelection = [];
        this.multipleSelectionItem = [];
        this.allCheck = false;
      },
      searchClick(value,columName) {
        this.query[columName] = value;
        this.getData();
      },
      // 分页导航
      handlePageChange(val) {
        this.query.pageIndex = val
        this.getData();
      },
      //把每一行的索引放进row
      tableRowClassName ({row, rowIndex}) {
        row.index = rowIndex + 1;
        if(row.isOvertime == '1'){     //如果超时状态等等于1的时候
          return 'overtime-row';
        }else if(row.returnNote != '' && row.returnNote != null && row.returnNote != 'undefined'){
          return 'warning-row';
        }
      },
      //点击当前行【关闭当前行】
      handleClickTableRow(row,col,event){
        if(!col){ //如果点击其他地方
          return false;
        }

        //先将所有的选中取消掉
        this.tableData.forEach(item => {
          item.checked = false
        })
        if(row){
          //将当前行选中
          row.checked = true;
          this.radio_value = row[this.configure.idField];
          this.radio_row = row;
          this.tableData.splice(1,0);
          this.refreshSelectList();
          //单行事件【调用父方法】
          if(this.configure.onClickRow){
            this.configure.onClickRow(row);
          }
        }


      },
      //双击当前行(左表)
      handleDBClickLeftTableRow(row,col,event){
        this.leftTransfer()
        //单行事件【调用父方法】
        // if(this.configure.onDBClickRow){
        //   this.configure.onDBClickRow(row);
        // }
      },
      //点击checkbox【正常表格】
      handleSelection(e,row){
        //防止冒泡
        if (e.target.tagName === 'SPAN') return;

        //1、若有子集先让子选中
        if (row.children) {
          this.setChildToBeSelect(row.children, !row.checked);

          //展开
          row.isExpand = true;
        }

        if(row.checked){
          row.checked = false;
        }else {
          row.checked = true;
        }
        this.tableData.splice(1,0);
        this.refreshSelectList();
      },
      //正选/反选 子的checkbox
      setChildToBeSelect(arr, key){
        arr.forEach((v, i) => {
          v.checked = key;
        })
      },
      //全选【正常表格】
      handleAllSelection(e){
        //防止冒泡
        if (e.target.tagName === 'SPAN') return;



        //如果不是所有都选中，就全选，否则反选
        if(this.allCheck){   //全选了，设置反选
          this.tableData.forEach(item => {
            item.checked = false
            if(item.children){
              this.setChildToBeSelect(item.children,false);
            }
          })
        }else {
          this.tableData.forEach(item => {
            item.checked = true
            if(item.children){
              this.setChildToBeSelect(item.children,true);
            }
          })
        }
        this.tableData.splice(1,0);
        this.refreshSelectList();
      },
      //关闭快捷查询
      closeQuickSearch(){
        this.configure.isShowSearch = false;
      },
      //重置搜索框
      closeResetSearch(){
        this.configure.columns.forEach(item => {
          if(item.condition && item.condition.searchName){
            this.query[item.condition.searchName] = ''
            item.condition.value = ''
          }
        });
      },
      //右上角的点击事件
      moreFunClick(command){
        if (command == 'refresh') {  //如果是 【刷新】
          // location.reload();
          this.getData();
        } else if (command == 'export') {
          this.exportFile();
        } else if(command == 'quickSearch'){
          if(this.configure.isShowSearch){
            this.configure.isShowSearch = false;
          }else {
            this.configure.isShowSearch = true;
          }
        }else if(command == 'resetSearch'){
          this.closeResetSearch();
        }else if(command == 'tableSetting'){
          this.tableColumnSetting();
        }
      },
      //查询
      submit(){
        let pageIndex = this.query.pageIndex;
        let showCount = this.query.showCount;
        let page = this.query.page;

        let query = new Object();
        query.pageIndex = pageIndex;
        query.showCount = showCount;
        query.page = page;

        let columns = this.configure.columns;
        for (let i = 0; i < columns.length; i++) {
          if(!!columns[i]&&!!columns[i].condition&&!!columns[i].condition.searchName){
            query[columns[i].condition.searchName] = columns[i].condition.value
          }
        }

        this.query = query;
        this.getData();  //重新加载表格
      },
      //右侧查询
      submitRight(){
        // let query = new Object();
        // let columns = this.configure.columns;
        // for (let i = 0; i < columns.length; i++) {
        //   if(!!columns[i]&&!!columns[i].condition&&!!columns[i].condition.searchName&&!!columns[i].condition.rightValue){
        //     query[columns[i].field] = columns[i].condition.rightValue
        //   }
        // }
        // let rightList = this.rightData
        // rightList = rightList.filter(item => {
        //   const keys = Object.keys(query);
        //   for (let i = 0; i < keys.length; i++) {
        //     const key = keys[i];
        //     if (!item[key].includes(query[key])) {
        //       return false;
        //     }
        //   }
        //   return true;
        // });
        //
        // this.rightData = rightList
      },
      //修改排序
      changeSort(val){
        //需要先清除默认排序 ！！!
        if (this.$refs.table) this.$refs.table.clearSort()

        this.pageIndex = 1;
        this.query['orderColumn'] = val.prop;
        this.query['orderType'] = val.order;
        this.getData();   //重新加载表格

        return false;
      },
      //切换【每页显示数】
      handleSizeChange(val){
        this.pageSize = val
        this.pageIndex = 1
        this.getData()
      },
      //切换【页数】
      handleCurrentChange(val){
        this.pageIndex = val
        this.getData()
      },
      rowData(row) {
        return row;
      },
      //修改某一列的值
      editRowColumnData(id, columnName, value){
        if(!this.configure.idField || !columnName){
          return false;
        }
        let tableData = this.tableData;
        let index = -1;
        for(let i = 0; i < tableData.length; i ++){
          if(tableData[i][this.configure.idField] == id){
            index = i;
          }
        }
        if(index < 0){
          return false;
        }
        this.tableData[index][columnName] = value;
      },
      refreshRowData(row){
        //刷新数据
        row.isEdit = true;
        if(this.$refs.normalTable){
          this.$set(this.$refs.normalTable.tableData,row.index - 1,row);
        }else if(this.$refs.multipleTable){
          this.$set(this.$refs.multipleTable.tableData,row.index - 1,row);
        }
        // this.getData(false);
      },
      //
      editDataCallback(columnName,columnValue){
        //修改数据事件【调用父方法】
        if(this.configure.editDataCallback){
          this.configure.editDataCallback(columnName, columnValue);
        }
      },
      //合并列
      arraySpanMethod({row, column, rowIndex, columnIndex}){
        if (row.columnType == 'parent') { // 在这里多加一个行的判断就行
          // 合并第二行
          if (columnIndex === this.configure.multiple.mergeStartIndex) {
            return [this.configure.multiple.mergeStartIndex, this.configure.multiple.mergeEndIndex]
          } else if (columnIndex > this.configure.multiple.mergeStartIndex) {
            return [0, 0]
          }
        }
      },
      //展开列
      expandChildren(row){
        if(row.isExpand){
          this.$refs.multipleTable.toggleRowExpansion(row,false);  //就是树形表格控制折叠和展开的语句  true是展开
          row.isExpand = false;
        }else {
          this.$refs.multipleTable.toggleRowExpansion(row,true);  //就是树形表格控制折叠和展开的语句  true是展开
          row.isExpand = true;
        }
        // this.$refs.TreeName.store.nodesMap[item.id].expanded =true/false; //就是控制树形控件折叠和展开的关键语句
      },
      //展开所有列
      toggleRowExpansionAll(data, isExpansion) {
        data.forEach((item) => {
          item['isExpand'] = isExpansion;
          this.$refs.multipleTable.toggleRowExpansion(item, isExpansion);
          if (item.children !== undefined && item.children !== null) {
            this.toggleRowExpansionAll(item.children, isExpansion);
          }
        });
      },
      cellClick(item,row){
        item.handler(row);
      },
      //导出文件
      exportFile(){
        let url = this.configure.url.replace('/web/service/', '/web/exportData/');
        return this.request({
          method: 'get',
          url: url,
          responseType: 'blob',
          params: {
            'str1':'12321'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }


        })
      },
      //表格列配置
      tableColumnSetting(){
        let id = this.configure.id;     //表格ID
        if(!id){
          alert("表格主键没有设置，无法配置！");
          return false;
        }
        this.isTableColumnSettingShow = true;
        this.$nextTick(()=>{
          this.$refs.tableColumnSetting.init(id, this.configure.columns) //初始化页面
        })
      },
      //初始化列
      initTableColumn(){
        if(!this.configure.id){
          return false;
        }
        let tableColumnStr = localStorage.getItem('#' + this.configure.id + '-table-column');
        if(tableColumnStr == null || tableColumnStr == '' || tableColumnStr == undefined){
          return false;
        }
        let list = JSON.parse(tableColumnStr);
        let tableColumnMap = new Object();
        for (let i = 0; i < list.length; i++) {
          let temp = list[i];
          if(temp == null || !temp.tableColumn || temp.isShow == null || temp.isShow == '' || temp.isShow == undefined ){
            continue;
          }
          tableColumnMap[temp.tableColumn] = temp.isShow;
        }
        console.log(tableColumnMap);
        let columns = this.configure.columns;
        for (let i = 0; i < columns.length; i++) {
          let temp = columns[i];
          if(temp == null || temp.field == null || temp.field == '' || temp.field == undefined){
            continue
          }
          if(tableColumnMap[temp.field] != null && tableColumnMap[temp.field] != '' && tableColumnMap[temp.field] != undefined){
            temp['isShow'] = tableColumnMap[temp.field];
          }
        }
        this.configure.columns = columns;
        this.configure.columns.splice(1,0);   //刷新表格
        console.log(this.configure.columns);
      },
      //假的无事件的点击函数
      handleNoClick(ev){
        ev.stopPropagation();
        return false;
      },
      //工具栏的通用点击方法
      toolbarClick(type){
        if(type == 'deleteBatch'){  //如果是删除操作
          this.deleteBatch();
        }else if(type == 'addOne'){   //直接添加一个
          this.addOne();
        }
      },
      //直接新增一个
      addOne(){
        return this.request({
          method:'post',
          url:'/web/service?method=' + this.configure.moduleName + '_save',
          params: this.configure.listParam
        }).then((response) =>{
          if (response.code != 0) {
            this.$message.error(response.msg);
            return false;
          }
          this.getData();
        })
      },
      //删除操作 请至少选择一条数据
      deleteBatch(){
        //获取选中的list的数组
        let list = this.multipleSelection;
        if(list.length === 0){
          this.$message.warning("请至少选择一条数据")
          return false;
        }
        let confirmMsgHtml = '是否删除以下选中的项目？';
        for(let i = 0; i < list.length; i ++){
          confirmMsgHtml += '<p style="text-indent: 2em;">' + list[i] + '</p>';
        }
        this.$confirm(confirmMsgHtml, '确认删除',{
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          let ids = '';
          for(let i = 0;i < list.length;i++){
            ids = ids + list[i] + ",";
          }
          ids = ids.substring(0,ids.length-1);
          return this.request({
            method:'post',
            url:'/web/service',
            params:{
              'method': this.configure.moduleName + '_deleteBatch',
              'ids':ids
            }
          }).then((response) =>{
            if (response.code === 0) {
              this.$message({message: '删除成功！', type: 'success', duration: 1500, onClose: () => {
                  this.getData();
                }
              })
            } else {
              this.$message.error(response.msg)
            }
          })
        }).catch(() => {})
      },
      //右侧 全选【正常表格】
      handleRightAllSelection(e){
        //防止冒泡
        if (e.target.tagName === 'SPAN') return;

        //如果不是所有都选中，就全选，否则反选
        if(this.rightAllCheck){   //全选了，设置反选
          this.rightData.forEach(item => {
            item.checked = false
            if(item.children){
              this.setChildToBeSelect(item.children,false);
            }
          })
        }else {
          this.rightData.forEach(item => {
            item.checked = true
            if(item.children){
              this.setChildToBeSelect(item.children,true);
            }
          })
        }
        this.rightData.splice(1,0);
        this.refreshRightSelectList();
      },
      //刷新选择框
      refreshRightSelectList(){
        let rightMultipleSelection = [];
        let rightMultipleSelectionItem = []
        this.rightData.forEach(item => {
          if(item.children){
            item.children.forEach(child => {
              if(child.checked){
                rightMultipleSelection.push(child[this.configure.idField]);
                rightMultipleSelectionItem.push(child);
              }
            })
          }else {
            if(item.checked){
              rightMultipleSelection.push(item[this.configure.idField]);
              rightMultipleSelectionItem.push(item);
            }
          }
        });
        this.rightMultipleSelection = rightMultipleSelection;
        this.rightMultipleSelectionItem = rightMultipleSelectionItem;
        //如果全选了，设置全选
        if(this.rightMultipleSelection.length > 0 && this.rightMultipleSelection.length == this.rightData.length){
          this.rightAllCheck = true;
        }else {
          this.rightAllCheck = false;
        }
      },
      //点击右侧的checkbox框
      handleRightSelection(e, row){
        //防止冒泡
        if (e.target.tagName === 'SPAN') return;
        if(row.checked){
          row.checked = false;
        }else {
          row.checked = true;
        }
        this.rightData.splice(1,0);
        this.refreshRightSelectList();
      },
      //左侧转移到右边
      leftTransfer(){
        if(this.multipleSelection.length == 0){
          return false;
        }
        let rightData = this.rightData;
        let ids = ',';
        for(let i = 0; i < rightData.length; i++){
          ids += rightData[i][this.configure.idField] + ',';
        }
        for(let i = 0; i < this.multipleSelectionItem.length; i++){
          this.multipleSelectionItem[i]['checked'] = false;
          if(ids.indexOf(',' + this.multipleSelectionItem[i][this.configure.idField] + ',') == -1){  //如果不存在，则加入
            rightData.push(this.multipleSelectionItem[i]);
            ids += this.multipleSelectionItem[i][this.configure.idField] + ',';
          }
        }

        console.log('++++++++++++++++++++++++++++++++++++++++++++++++++');
        console.log(this.multipleSelection);
        console.log(rightData);
        console.log('++++++++++++++++++++++++++++++++++++++++++++++++++');


        this.rightData = rightData;
        this.configure.listParam['excludeIds'] = ids;
        this.getData() //刷新列表
      },
      //右侧转移到昨天
      rightTransfer(){
        let rightMultipleSelection = this.rightMultipleSelection;
        let rightData = this.rightData;

        console.log('++++++++++++');
        console.log(rightData);
        console.log(rightMultipleSelection);
        console.log(this.configure.idField);

        for(let i = 0; i< rightData.length; i ++){
          console.log('++' + i +  '++++++++++');
          console.log(rightData[i][this.configure.idField]);

          if(rightMultipleSelection.indexOf(rightData[i][this.configure.idField]) != -1){
            console.log('+++进来了+++++');
            rightData.splice(i, 1);
            i --;
          }
        }
        let ids = ',';
        for(let i = 0; i < rightData.length; i++){
          ids += rightData[i][this.configure.idField] + ',';
        }
        this.rightData = rightData;
        this.configure.listParam['excludeIds'] = ids;
        // this.getData() //刷新列表
        this.refreshRightSelectList();
      }

    }
  }
</script>

<style lang="scss" scoped>




  .main-table .pagination{text-align: center;}

  .el-pagination .el-pagination__total{color: rgba(0,0,0,.45)}

  .el-table .cell{
    height: 100%;
  }

  .el-select{
    width: 100% !important;
  }

  .operate-div a{text-decoration: none;color: #007aff;height: auto;width: 100%;margin: 0 10px;}


</style>



// WEBPACK FOOTER //
// src/components/XrTable/table-select.vue